import { theme } from '@factorialco/deprecated-design-system'
import { ThemeAPI } from 'nuvo-react'

export const popover: ThemeAPI['popover'] = {
  info: {
    root: {
      color: theme.colors.white,
      backgroundColor: theme.colors.grey400,
      borderColor: theme.colors.grey400,
    },
  },
  warning: {
    root: {
      color: theme.colors.white,
      backgroundColor: theme.colors.warningBackgroundSolid,
      borderColor: theme.colors.warningBackgroundSolid,
    },
  },
  error: {
    root: {
      color: theme.colors.white,
      backgroundColor: theme.colors.criticalBackgroundSolid,
      borderColor: theme.colors.criticalBackgroundSolid,
    },
  },
}
